module.exports = __webpack_public_path__ + "img/룬마스터.460850d6.png";